import labels from './labels';
import messages from './messages';
import notifications from './notifications';
import buttons from './buttons';

export default { ...labels, ...messages, ...notifications, ...buttons };
